import { html, css } from 'lit'
import HHQuizElement from '../element.js'

/**
 * Quiz progress bar (for navigation links)
 * @extends
 */

class HHQuizProgressBar extends HHQuizElement {
  static properties = {
    /**
     * Progress (0-1)
     * @type {Number}
     * @default 0
     */
    progress: { type: Number },
    /**
     * Animate progress bar
     * @type {Boolean}
     * @default true
     */
    animate: { type: Boolean, default: true },

    /**
     * Rounded bar
     * @type {Boolean}
     * @default false
     */
    rounded: { type: Boolean, default: false },
  }

  render() {
    return html` <style>
        .hh-quiz-progress-bar__progress {
          width: ${Math.min(this.progress, 1) * 100}%;
        }
        .hh-quiz-progress-bar__progress {
          ${this.animate ? 'transition: width 0.3s ease-in-out;' : ''}
        }
      </style>
      <div class="hh-quiz-progress-bar ${this.rounded ? 'is-rounded': ''}">
        <div class="hh-quiz-progress-bar__progress"></div>
      </div>`
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-progress-bar {
        width: 100%;
        background: var(--hh-color-grey-mineral);
        height: 4px;
        margin-bottom: 10px;
        position: relative;
        overflow: hidden;
      }

      .hh-quiz-progress-bar.is-rounded {
        border-radius: 10px;
      }
      .hh-quiz-progress-bar__progress {
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        background: var(--hh-color-honey-two);
      }
    `,
  ]
}

customElements.define('hh-quiz-progress-bar', HHQuizProgressBar)
